// import logo from './logo.svg';
import React, { useState } from 'react';
import './App.css';
import Alert from './components/Alert';
// import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
// import {BrowserRouter as Router, Routes , Route} from 'react-router-dom'

function App() {
  const [mode, setMode] = useState("light"); //whether dark mode enabled or not //setMode is a function to set the value of mode
  const [alert,setAlert] = useState(null);
  
  const showAlert = (message, type)=>{
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(()=>{
      setAlert(null);
    }, 1500);
  }
  const toggleMode = ()=>{
    if(mode === 'light')
    {
      setMode('dark');
      document.body.style.backgroundColor = '#05505a';
      showAlert("Dark mode has been enabled", "success");
      document.title = "TextUtils - Dark Mode";
      // setInterval(()=>{
      //   document.title = "TextUtils is amazing mode";
      // }, 2000);
      // setInterval(()=>{
      //   document.title = "Install TextUtils Now";
      // }, 1500);
    }
    else{
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light mode has been enabled", "success");
      document.title = "TextUtils - Light Mode";
    }
  }
  return (
    <>
      {/* <Router> */}
        <Navbar title ="TextUtils" aboutText = "About Us" mode = {mode} toggleMode = {toggleMode}/>
        <Alert alert={alert}/>
        <div className="container my-3">
        {/* <Routes>
              <Route exact path="/" element={<TextForm showAlert ={showAlert} heading="Enter the text to analyze below..." mode = {mode}/>}></Route>
              <Route exact path="/About" element={<About />}></Route> */}
              <TextForm showAlert ={showAlert} heading="Enter the text to analyze below..." mode = {mode}/>      
        {/* </Routes> */}
        </div>
      {/* </Router> */}
    </>
  );
}

export default App;
